import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { GGAiTroubleshootComponent } from './gg-ai-troubleshoot.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormErrorsModule } from '@spartacus/storefront';
import { MarkdownComponent } from 'ngx-markdown';
import { NgbPopover, NgbPopoverModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [GGAiTroubleshootComponent],
  imports: [
    CommonModule,
    NgbPopover,
    NgbPopoverModule,
    ConfigModule.withConfig({
      cmsComponents: {
        GGAiTroubleshootComponent: {
          component: GGAiTroubleshootComponent,
        },
      },
    } as CmsConfig),
    FormsModule,
    I18nModule,
    ReactiveFormsModule,
    FormErrorsModule,
    MarkdownComponent,
    NgbTooltip,
  ],
})
export class GgAiTroubleshootModule {}
